<template>
    <RedesignFormItem :label="t('layout.config.widgetTableRowPadding')">
        <VcInputNumber
            v-model="model"
            :max-value="optionConfigs.WidgetTableRowPadding.max"
            :min-value="optionConfigs.WidgetTableRowPadding.min"
            :step="optionConfigs.WidgetTableRowPadding.step"
            placeholder="12"
        />
    </RedesignFormItem>
</template>

<script setup lang="ts">
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import { VcInputNumber } from '@voicenter-team/voicenter-ui-plus'
import { computed } from 'vue'
import { optionConfigs } from '@/views/DashboardSettings/LayoutManagement/layout-management'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    modelValue?: number
}>()
const emit = defineEmits<{
    (e: 'update:modelValue', value: number | undefined): void
}>()
const model = computed({
    get () {
        return props.modelValue
    },
    set (val) {
        emit('update:modelValue', val)
    }
})
</script>
